export const chipContainerStyle = {
    padding: '0'
}

export const chipTextGroupStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 !important'
}

export const chipTextStyle = {
    fontSize: '0.688rem'
}

export const chipTextBoldStyle = {
    fontSize: '0.688rem',
    fontWeight: 'bold'
}

export const tableHeadStyle = {
    backgroundColor: '#8C755D0D',
    borderTop: '1px solid #E8E6E3',
    width: '100%'
}

export const tableFirstColumnStyle = {
    padding: '0 16px',
    width: '25%',
    verticalAlign: 'text-top',
    borderBottom: '1px solid #E8E6E3',
    borderRight: '1px solid #E8E6E3',
    borderLeft: '1px solid #E8E6E3'
}

export const tableSecondColumnStyle = {
    padding: '0 16px',
    width: '75%',
    borderRight: '1px solid #E8E6E3'
}

export const tableChipContainerStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    // width: '100%',
    height: '100%',
    gap: '8px',
    padding: '20px',
    borderBottom: '1px solid #E8E6E3',
    borderRight: '1px solid #E8E6E3'
}

export const COLORS = [
    '#ffffff',
    '#ECE9E6',
    '#D9F3FF',
    '#E0D7F7',
    '#FFE5DA'
]
